// Applies the user's theme preference ("light" | "dark" | "system") as a `dark` class on <html>.
// The colours themselves live in dark.css.
const media = window.matchMedia
  ? window.matchMedia("(prefers-color-scheme: dark)")
  : null;

let current = "light";

function render() {
  const dark = current === "dark" || (current === "system" && media && media.matches);
  document.documentElement.classList.toggle("dark", !!dark);
}

if (media && media.addEventListener) {
  media.addEventListener("change", render);
}

export function applyTheme(theme) {
  current = theme || "light";
  render();
}
